import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fetch from 'whatwg-fetch'; // eslint-disable-line no-unused-vars
import API from 'lib/tessitura/API';
import features from 'lib/common/features';

const STATUSES = {
  NOT_ASKED: 'NOT_ASKED',
  VALIDATING: 'VALIDATING',
  PENDING: 'PENDING',
  REMOVING: 'REMOVING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

class PromoCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      status: STATUSES.NOT_ASKED,
      activePromoCode: false,
      endpoints: features.getOption('promoCode', 'endpoints')
    };

    this.addPromoCode = this.addPromoCode.bind(this);
    this.removePromoCode = this.removePromoCode.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      status: STATUSES.VALIDATING
    });

    API.GetCurrentPromoCode().then(
      response => {
        const activePromoCode = response.result;
        if (activePromoCode) {
          this.props.onPromoCodeReady(activePromoCode);
          this.setState({
            status: STATUSES.SUCCESS,
            activePromoCode: activePromoCode
          });
        } else {
          this.setState({
            status: STATUSES.NOT_ASKED
          });
        }
      },
      () => {
        this.setState({
          status: STATUSES.NOT_ASKED
        });
      }
    );
  }

  addPromoCode(promoCode) {
    this.setState({
      status: STATUSES.PENDING
    });

    return API.addPromoCode(promoCode)
      .then(() => {
        this.setState({
          status: STATUSES.SUCCESS
        });
      })
      .catch(() => {
        this.setState({
          status: STATUSES.FAILURE
        });
      });
  }

  removePromoCode() {
    this.setState({
      status: STATUSES.REMOVING
    });

    return API.removePromoCode()
      .then(() => {
        this.setState({
          status: STATUSES.NOT_ASKED
        });
      })
      .catch(() => {
        this.setState({
          status: STATUSES.FAILURE
        });
      });
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    let inputValue = this.state.value;

    if (this.state.activePromoCode) {
      this.removePromoCode();
    } else if (inputValue) {
      this.addPromoCode(inputValue);
    }
  }

  render() {
    const buttonLabel = (() => {
      const labels = {
        NOT_ASKED: 'Apply',
        PENDING: 'Applying',
        REMOVING: 'Removing',
        SUCCESS: 'Remove',
        FAILURE: 'Apply'
      };

      return labels[this.state.status] || labels[STATUSES.NOT_ASKED];
    })();

    return this.state.status === STATUSES.VALIDATING ? (
      <p className="promo-code-loading">
        Checking for existing promotional code...
      </p>
    ) : (
      <form className="promo-code-form" action="" onSubmit={this.handleSubmit}>
        <div className="promo-code-form__field">
          <div className="input-addon">
            <input
              className="input-addon__input"
              type="text"
              onChange={this.handleChange}
              placeholder="Promotional Code"
              value={this.state.activePromoCode || this.state.value}
              readOnly={this.state.activePromoCode}
            />
            <input
              className="input-addon__action syos-button"
              type="submit"
              disabled={this.state.status === STATUSES.PENDING}
              value={buttonLabel}
            />
          </div>
        </div>
        {this.state.status === STATUSES.FAILURE && (
          <p className="promo-code-form__message">
            The promotional code you entered is not valid
          </p>
        )}
      </form>
    );
  }
}

PromoCode.propTypes = {
  onPromoCodeReady: PropTypes.func.isRequired
};

export default PromoCode;



// WEBPACK FOOTER //
// ./src/javascripts/components/PromoCode.js